import { ClickButton } from "./ClickButton";
import { ToggleVisual } from "./Toggle";

export function SkillAiAccessToggle({
  enabled,
  disabled,
  skillName,
  onToggle,
}: {
  enabled: boolean;
  disabled: boolean;
  skillName: string;
  onToggle: () => void;
}) {
  return (
    <span
      style={{ display: "inline-flex" }}
      onPointerDown={(event) => event.stopPropagation()}
      onMouseDown={(event) => event.stopPropagation()}
      onClick={(event) => {
        event.preventDefault();
        event.stopPropagation();
      }}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") event.stopPropagation();
      }}
    >
      <ClickButton
        role="switch"
        aria-label={`AI access for ${skillName}`}
        aria-checked={enabled}
        disabled={disabled}
        onClick={onToggle}
      >
        <ToggleVisual isOn={enabled} />
      </ClickButton>
    </span>
  );
}
